import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Grid from '../../Grid';
import Image from '../../Image';
import Typography from '../../Typography';
import styles from '../../PackageItem/PackageItem.module.sass';
import previousStyles from './PreviousYears.module.sass';
import { CustomerContext } from '../../../contexts/CustomerContext';
import OrderPackage from '../../../models/OrderPackage';
import useLocalStorage from '../../../hooks/useLocalStorage';
import prevYearsBanner from '../../../assets/prev_years.png';
import usePastImages from "../../../hooks/usePastImages";
import usePastImagesPricelists from "../../../hooks/usePastImagesPricelists";
import PreviewImage from "../../PreviewImage";
import useBreakpoints from '../../../hooks/use-breakpoints'; // Import useBreakpoints

const PreviousYears = ({ student }) => {
  const { customer, setCustomer } = useContext(CustomerContext);
  const [display, setDisplay] = useState(styles.hidden);
  const history = useHistory();
  const { isLoading: isLoadingPastImages, data: pastImages } = usePastImages({ studentId: student.id });
  const { isLoading: isLoadingPricelists, data: pricelists } = usePastImagesPricelists();
  const backgrounds = pastImages && pricelists[0]?.backgroundSet?.backgrounds;
  const poseOne = pastImages && pastImages[0]?.watermarkUrl;
  const poseTwo = pastImages && (pastImages[1] || pastImages[0])?.watermarkUrl;
  const poseThree = pastImages && (pastImages[2] || pastImages[0])?.watermarkUrl;

  // Detect the current breakpoint (e.g., 'xs', 'sm', 'md', 'lg', 'xl')
  const breakpoint = useBreakpoints();

  const handleSelection = () => {
    const orderPackage = new OrderPackage({
      packageId: '99_999',
      cartId: customer.cart.id,
      isPreviewHidden: false,
    });

    setCustomer({ ...customer, currentOrderPackage: orderPackage });
    history.push('/past_images');
  };

  if (!backgrounds || backgrounds.length === 0 || !poseOne) return <></>;

  console.log(backgrounds && backgrounds.length > 0 ? backgrounds[0] : 'No backgrounds available');

  // Determine if it's a mobile breakpoint (adjust as per your breakpoint definitions)
  const isMobile = ['xs', 'sm', 'md'].includes(breakpoint); // Assuming 'xs', 'sm', 'md' are mobile breakpoints

  // Choose the appropriate class based on the device type
  const gridClasses = cn(
    styles.packageItem,
    display,
    {
      [previousStyles.previousYearsMobile]: isMobile, // Apply this class if on mobile
      [previousStyles.previousYearsDesktop]: !isMobile, // Apply this class if not on mobile (desktop)
    }
  );

  return (
    <Grid
      item
      container
      xs={11}
      classes={gridClasses} // Use the dynamically determined class
      onClick={handleSelection}
    >
      <Image classes={styles.itemImg} src={prevYearsBanner} onLoad={() => setDisplay(undefined)} />
      <div className={previousStyles.poseThree}>
        <PreviewImage
          foregroundUrl={poseThree}
        />
      </div>
      <div className={previousStyles.poseOne}>
        <PreviewImage
          foregroundUrl={poseOne}
          backgroundUrl={backgrounds && backgrounds.length > 0 ? backgrounds[0].imageUrl : ''}
        />
      </div>

      <div className={previousStyles.poseTwo}>
        <PreviewImage
          foregroundUrl={poseTwo}
          backgroundUrl={backgrounds && backgrounds.length > 1 ? backgrounds[1].imageUrl :
            backgrounds && backgrounds.length > 0 ? backgrounds[0].imageUrl : ''}
        />
      </div>
    </Grid>
  );
};

export default PreviousYears;